import { render } from "./RevokeWebAccessDialog.vue?vue&type=template&id=1ffb0a78&scoped=true"
import script from "./RevokeWebAccessDialog.vue?vue&type=script&lang=js"
export * from "./RevokeWebAccessDialog.vue?vue&type=script&lang=js"

import "./RevokeWebAccessDialog.vue?vue&type=style&index=0&id=1ffb0a78&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffb0a78"]])

export default __exports__